import React, { createContext, useContext } from 'react';
import { assertNotNil } from '../../utils/types';

export interface IEntityInfoPopoverContext {
  // We have to be able to close popover in children
  // for example Expand named cohort
  closePopover: (event: React.SyntheticEvent) => void;
}

export const EntityInfoPopoverContext =
  createContext<IEntityInfoPopoverContext | null>(null);

export const useEntityInfoPopoverContext = () => {
  const context = useContext(EntityInfoPopoverContext);
  assertNotNil(context);
  return context;
};
